<p-divider
  layout="{{ props.vertical ? 'vertical' : 'horizontal' }}"
  ngClass="p-divider-vertical: props.vertical"
  [styleClass]="props.styleClass"
  [style]="props.style"
  [type]="props.type ?? 'solid'"
  [align]="props.align ?? 'center'"
  ><b *ngIf="props.text" class="basin-body-small">{{
    props.text
  }}</b></p-divider
>
